import { render, staticRenderFns } from "./admin-map.vue?vue&type=template&id=2da41fa1"
import script from "./admin-map.vue?vue&type=script&lang=js"
export * from "./admin-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da41fa1')) {
      api.createRecord('2da41fa1', component.options)
    } else {
      api.reload('2da41fa1', component.options)
    }
    module.hot.accept("./admin-map.vue?vue&type=template&id=2da41fa1", function () {
      api.rerender('2da41fa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Map/admin-map.vue"
export default component.exports